import { Paper } from 'src/design/atoms/Paper';
import { Title } from 'src/design/atoms/Title';
import { Tabs } from 'src/design/molecules/Tabs';
import React from 'react';
import { useWbs } from 'src/routes/Jobs/WBS/contexts/WbsContext';
import { AdjustmentsTab } from './AdjustmentsTab';
import { EditAccountForm } from './EditAccountForm';

export const AccountPanel: React.FC = () => {
  const { selectedTreeRow, isPlaceholderAccount, accountMap } = useWbs();

  if (!selectedTreeRow) {
    return null;
  }

  return (
    <Paper>
      <Title order={4} mb="md">
        {`${accountMap.get(selectedTreeRow.id)?.path ?? selectedTreeRow.name}`}
      </Title>

      <Tabs defaultValue="account" keepMounted={false}>
        <Tabs.List>
          <Tabs.Tab value="account">Account</Tabs.Tab>
          <Tabs.Tab
            value="adjustments"
            disabled={
              selectedTreeRow.isArtificial ||
              !selectedTreeRow.isLeaf ||
              isPlaceholderAccount(selectedTreeRow.apply)
            }
          >
            Adjustments
          </Tabs.Tab>
        </Tabs.List>

        <Tabs.Panel value="account" pt="md">
          <EditAccountForm />
        </Tabs.Panel>

        <Tabs.Panel value="adjustments" pt="md">
          <AdjustmentsTab />
        </Tabs.Panel>
      </Tabs>
    </Paper>
  );
};
